import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import privateAxios from "../utils/axiosPrivate";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";
import { commonErrMsg } from "../locales/en";
import {
  getLoanManagementFMFBquoteURL,
  getUpdateFundedAmountURL
} from "../utils/constants/apiEndPoints";

const initialState = {
  loading: false,
  toFundLoader: false
};

//  Slice
const fundedAmountSlice = createSlice({
  name: "fundedAmount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateFundedAmountThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateFundedAmountThunk.fulfilled, (state, action) => {
        state.loading = false;

        showToast(action.payload.message, showToastType.success);
      })
      .addCase(updateFundedAmountThunk.rejected, (state, action) => {
        state.loading = false;

        const message = action.payload?.message || commonErrMsg.item2;
        showToast(message, showToastType.error);
      })
      .addCase(getLoanManagementquoteThunk.pending, (state) => {
        state.toFundLoader = true;
      })
      .addCase(getLoanManagementquoteThunk.fulfilled, (state) => {
        state.toFundLoader = false;
      })
      .addCase(getLoanManagementquoteThunk.rejected, (state) => {
        state.toFundLoader = false;
      });
  }
});

export const updateFundedAmountThunk = createAsyncThunk(
  "fundedAmount/update",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.put(
        getUpdateFundedAmountURL,
        payload
      );
      return response.data;
    } catch (error) {
      const errPayload = error?.response?.data || {
        message: commonErrMsg.item2
      };
      return rejectWithValue(errPayload);
    }
  }
);

export const getLoanManagementquoteThunk = createAsyncThunk(
  "invoice/getLoanManagementquoteThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getLoanManagementFMFBquoteURL(Number(payload))
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export default fundedAmountSlice.reducer;
